export default __webpack_public_path__ + "static/media/scrapy.eec039a5.png";